<script>
    export let row = null;
    export let col = '';
</script>

<style>

</style>

{row[col] ? row[col] : ''}